import React from 'react';

const BasemapItem = (props) => {
  return props.type === 'topo' ? (
    <div
      className={
        props.topoActiveIndex === props.index
          ? 'fs-basemap-topo-item-container active'
          : 'fs-basemap-topo-item-container'
      }
      onClick={() => {
        props.onTopoItemClick(props.index, props.service.name);
      }}
    >
      <div className="services-position">
        {images[props.service.image] ? (
          <img
            className="fs-basemap-topo-image"
            src={images[props.service.image]}
            alt={props.service.image}
          />
        ) : (
          <img
            className="fs-basemap-topo-image"
            alt={props.service.image}
            style={{ backgroundColor: 'lightgray', borderRadius: '10px' }}
          />
        )}

        <div className="service-name">{props.service.name}</div>
      </div>
    </div>
  ) : (
    <div
      className={
        props.dguActiveIndex === props.index
          ? 'fs-basemap-topo-item-container active'
          : 'fs-basemap-topo-item-container'
      }
      onClick={() => {
        props.onDguItemClick(props.index, props.service.name);
      }}
    >
      <div className="services-position">
        <img
          className="fs-basemap-topo-image"
          src={images[props.service.image]}
          alt={props.service.image}
        />

        <div className="service-name">{props.service.name}</div>
      </div>
    </div>
  );
};

export default BasemapItem;
// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
